<!--<template>-->
<!--    <div>-->
<!--        &lt;!&ndash; Page Title &ndash;&gt;-->
<!--        <h1 class="text-2xl font-medium text-gray-800 mb-8 p-6">Frequent Beneficiary</h1>-->

<!--        &lt;!&ndash;        Internal Beneficiaries Section&ndash;&gt;-->
<!--        <div class="mb-8">-->
<!--            <h2 class="text-lg font-medium text-gray-700 mb-4">INTERNAL BENEFICIARIES</h2>-->
<!--            <div class="bg-white border border-gray-200 rounded-lg overflow-hidden">-->
<!--                <div class="grid grid-cols-12 gap-4 p-4 border-b border-gray-200 bg-gray-50">-->
<!--                    <div class="col-span-4 text-sm font-medium text-gray-600">Description</div>-->
<!--                    <div class="col-span-5 text-sm font-medium text-gray-600">Beneficiary Account</div>-->
<!--                    <div class="col-span-3 text-sm font-medium text-gray-600 text-right">Operations</div>-->
<!--                </div>-->
<!--                <div class="grid grid-cols-12 gap-4 p-4 border-b border-gray-200">-->
<!--                    <div class="col-span-4 text-sm text-gray-500">Gilbert Blake</div>-->
<!--                    <div class="col-span-5 text-sm text-gray-500">DE16370501981901327682</div>-->
<!--                    <div class="col-span-3 flex justify-end gap-2">-->
<!--                        <button class="p-1 text-primary hover:text-orange-600">-->
<!--                            <component :is="UserRoundPen" class="w-6 h-6"/>-->
<!--                        </button>-->
<!--                        <button class="p-1 text-primary hover:text-orange-600">-->
<!--                            <component :is="Trash2" class="w-6 h-6"/>-->
<!--                        </button>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="flex justify-center mt-4">-->
<!--                <button class="bg-primary text-white px-8 py-2 rounded-lg font-medium">-->
<!--                    NEW BENEFICIARY-->
<!--                </button>-->
<!--            </div>-->
<!--        </div>-->

<!--&lt;!&ndash;        Other National and European Bank Beneficiaries Section&ndash;&gt;-->
<!--        <div class="mb-8">-->
<!--            <h2 class="text-lg font-medium text-gray-700 mb-4">OTHER NATIONAL AND EUROPEAN BANK BENEFICIARIES</h2>-->
<!--            <div class="bg-white border border-gray-200 rounded-lg overflow-hidden">-->
<!--                <div class="grid grid-cols-12 gap-4 p-4 border-b border-gray-200 bg-gray-50">-->
<!--                    <div class="col-span-4 text-sm font-medium text-gray-600">Description</div>-->
<!--                    <div class="col-span-5 text-sm font-medium text-gray-600">Beneficiary Account</div>-->
<!--                    <div class="col-span-3 text-sm font-medium text-gray-600 text-right">Operations</div>-->
<!--                </div>-->
<!--                <div class="grid grid-cols-12 gap-4 p-4 border-b border-gray-200">-->
<!--                    <div class="col-span-4 text-sm text-gray-500">Gilbert Blake</div>-->
<!--                    <div class="col-span-5 text-sm text-gray-500">DE16370501981901327682</div>-->
<!--                    <div class="col-span-3 flex justify-end gap-2">-->
<!--                        <button class="p-1 text-primary hover:text-orange-600">-->
<!--                            <component :is="UserRoundPen" class="w-6 h-6"/>-->
<!--                        </button>-->
<!--                        <button class="p-1 text-primary hover:text-orange-600">-->
<!--                            <component :is="Trash2" class="w-6 h-6"/>-->
<!--                        </button>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="grid grid-cols-12 gap-4 p-4 border-b border-gray-200">-->
<!--                    <div class="col-span-4 text-sm text-gray-500">Gilbert Blake</div>-->
<!--                    <div class="col-span-5 text-sm text-gray-500">DE06370400440155722200</div>-->
<!--                    <div class="col-span-3 flex justify-end gap-2">-->
<!--                        <button class="p-1 text-primary hover:text-orange-600">-->
<!--                            <component :is="UserRoundPen" class="w-6 h-6"/>-->
<!--                        </button>-->
<!--                        <button class="p-1 text-primary hover:text-orange-600">-->
<!--                            <component :is="Trash2" class="w-6 h-6"/>-->
<!--                        </button>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="flex justify-center mt-4">-->
<!--                <button class="bg-primary text-white px-8 py-2 rounded-lg font-medium">-->
<!--                    NEW BENEFICIARY-->
<!--                </button>-->
<!--            </div>-->
<!--        </div>-->

<!--&lt;!&ndash;        Other International Bank Beneficiaries Section&ndash;&gt;-->
<!--        <div class="mb-8">-->
<!--            <h2 class="text-lg font-medium text-gray-700 mb-4">OTHER INTERNATIONAL BANK BENEFICIARIES</h2>-->
<!--            <div class="bg-white border border-gray-200 rounded-lg overflow-hidden">-->
<!--                <div class="grid grid-cols-12 gap-4 p-4 border-b border-gray-200 bg-gray-50">-->
<!--                    <div class="col-span-4 text-sm font-medium text-gray-600">Description</div>-->
<!--                    <div class="col-span-5 text-sm font-medium text-gray-600">Beneficiary Account</div>-->
<!--                    <div class="col-span-3 text-sm font-medium text-gray-600 text-right">Operations</div>-->
<!--                </div>-->
<!--                <div class="grid grid-cols-12 gap-4 p-4 border-b border-gray-200">-->
<!--                    <div class="col-span-4 text-sm text-gray-500">ZHOUSHAN RUNXIN SCREW CO.,LTD</div>-->
<!--                    <div class="col-span-5 text-sm text-gray-500">2010002067189972</div>-->
<!--                    <div class="col-span-3 flex justify-end gap-2">-->
<!--                        <button class="p-1 text-primary hover:text-orange-600">-->
<!--                            <component :is="UserRoundPen" class="w-6 h-6"/>-->
<!--                        </button>-->
<!--                        <button class="p-1 text-primary hover:text-orange-600">-->
<!--                            <component :is="Trash2" class="w-6 h-6"/>-->
<!--                        </button>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="flex justify-center mt-4">-->
<!--                <button class="bg-primary text-white px-8 py-2 rounded-lg font-medium">-->
<!--                    NEW BENEFICIARY-->
<!--                </button>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
<!--</template>-->

<!--<script setup>-->
<!--import { Trash2, UserRoundPen } from 'lucide-vue-next'-->

<!--// Component logic can be added here for handling beneficiary operations-->
<!--// const handleEdit = (beneficiary) => {-->
<!--//     console.log('Edit beneficiary:', beneficiary)-->
<!--// }-->
<!--//-->
<!--// const handleDelete = (beneficiary) => {-->
<!--//     console.log('Delete beneficiary:', beneficiary)-->
<!--// }-->
<!--//-->
<!--// const handleNewBeneficiary = (type) => {-->
<!--//     console.log('Add new beneficiary for:', type)-->
<!--// }-->
<!--</script>-->



<template>
  <div>
    <!-- Page Title -->
    <h1 class="text-2xl font-medium text-gray-800 mb-8 p-6">Frequent Beneficiary</h1>

    <!-- Internal Beneficiaries Section -->
    <div class="mb-8">
      <h2 class="text-lg font-medium text-gray-700 mb-4">INTERNAL BENEFICIARIES</h2>
      <div class="bg-white border border-gray-200 rounded-lg overflow-hidden">
        <div class="grid grid-cols-12 gap-4 p-4 border-b border-gray-200 bg-gray-50">
          <div class="col-span-4 text-sm font-medium text-gray-600">Description</div>
          <div class="col-span-5 text-sm font-medium text-gray-600">Beneficiary Account</div>
          <div class="col-span-3 text-sm font-medium text-gray-600 text-right">Operations</div>
        </div>
        <div v-for="beneficiary in beneficiariesFiltered('internal')" :key="beneficiary.id" class="grid grid-cols-12 gap-4 p-4 border-b border-gray-200">
          <div class="col-span-4 text-sm text-gray-500">{{ beneficiary.description }}</div>
          <div class="col-span-5 text-sm text-gray-500">{{ beneficiary.account_number }}</div>
          <div class="col-span-3 flex justify-end gap-2">
            <button @click="editBeneficiary(beneficiary)" class="p-1 text-primary hover:text-orange-600">
              <component :is="UserRoundPen" class="w-6 h-6"/>
            </button>
            <button @click="deleteBeneficiary(beneficiary.id)" class="p-1 text-primary hover:text-orange-600">
              <component :is="Trash2" class="w-6 h-6"/>
            </button>
          </div>
        </div>
      </div>
      <div class="flex justify-center mt-4">
        <button @click="newBeneficiary('internal')" class="bg-primary text-white px-8 py-2 rounded-lg font-medium">
          NEW BENEFICIARY
        </button>
      </div>
    </div>

    <!-- Other National and European Bank Beneficiaries Section -->
    <div class="mb-8">
      <h2 class="text-lg font-medium text-gray-700 mb-4">OTHER NATIONAL AND EUROPEAN BANK BENEFICIARIES</h2>
      <div class="bg-white border border-gray-200 rounded-lg overflow-hidden">
        <div class="grid grid-cols-12 gap-4 p-4 border-b border-gray-200 bg-gray-50">
          <div class="col-span-4 text-sm font-medium text-gray-600">Description</div>
          <div class="col-span-5 text-sm font-medium text-gray-600">Beneficiary Account</div>
          <div class="col-span-3 text-sm font-medium text-gray-600 text-right">Operations</div>
        </div>
        <div v-for="beneficiary in beneficiariesFiltered('national','european')" :key="beneficiary.id" class="grid grid-cols-12 gap-4 p-4 border-b border-gray-200">
          <div class="col-span-4 text-sm text-gray-500">{{ beneficiary.description }}</div>
          <div class="col-span-5 text-sm text-gray-500">{{ beneficiary.account_number }}</div>
          <div class="col-span-3 flex justify-end gap-2">
            <button @click="editBeneficiary(beneficiary)" class="p-1 text-primary hover:text-orange-600">
              <component :is="UserRoundPen" class="w-6 h-6"/>
            </button>
            <button @click="deleteBeneficiary(beneficiary.id)" class="p-1 text-primary hover:text-orange-600">
              <component :is="Trash2" class="w-6 h-6"/>
            </button>
          </div>
        </div>
      </div>
      <div class="flex justify-center mt-4">
        <button @click="newBeneficiary('national')" class="bg-primary text-white px-8 py-2 rounded-lg font-medium">
          NEW BENEFICIARY
        </button>
      </div>
    </div>

    <!-- Other International Bank Beneficiaries Section -->
    <div class="mb-8">
      <h2 class="text-lg font-medium text-gray-700 mb-4">OTHER INTERNATIONAL BANK BENEFICIARIES</h2>
      <div class="bg-white border border-gray-200 rounded-lg overflow-hidden">
        <div class="grid grid-cols-12 gap-4 p-4 border-b border-gray-200 bg-gray-50">
          <div class="col-span-4 text-sm font-medium text-gray-600">Description</div>
          <div class="col-span-5 text-sm font-medium text-gray-600">Beneficiary Account</div>
          <div class="col-span-3 text-sm font-medium text-gray-600 text-right">Operations</div>
        </div>
        <div v-for="beneficiary in beneficiariesFiltered('international')" :key="beneficiary.id" class="grid grid-cols-12 gap-4 p-4 border-b border-gray-200">
          <div class="col-span-4 text-sm text-gray-500">{{ beneficiary.description }}</div>
          <div class="col-span-5 text-sm text-gray-500">{{ beneficiary.account_number }}</div>
          <div class="col-span-3 flex justify-end gap-2">
            <button @click="editBeneficiary(beneficiary)" class="p-1 text-primary hover:text-orange-600">
              <component :is="UserRoundPen" class="w-6 h-6"/>
            </button>
            <button @click="deleteBeneficiary(beneficiary.id)" class="p-1 text-primary hover:text-orange-600">
              <component :is="Trash2" class="w-6 h-6"/>
            </button>
          </div>
        </div>
      </div>
      <div class="flex justify-center mt-4">
        <button @click="newBeneficiary('international')" class="bg-primary text-white px-8 py-2 rounded-lg font-medium">
          NEW BENEFICIARY
        </button>
      </div>
    </div>

    <!-- Beneficiary Modal (simplified) -->
    <div v-if="modalVisible" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40">
      <div class="bg-white p-6 rounded-lg w-96">
        <h3 class="text-lg font-medium mb-4">{{ editingBeneficiary ? 'Edit Beneficiary' : 'New Beneficiary' }}</h3>
        <input v-model="modalDescription" type="text" placeholder="Description" class="w-full p-3 border rounded mb-3"/>
        <input v-model="modalAccount" type="text" placeholder="Account Number" class="w-full p-3 border rounded mb-3"/>
        <div class="flex justify-end gap-2">
          <button @click="modalVisible=false" class="px-4 py-2 border rounded">Cancel</button>
          <button @click="saveBeneficiary" class="px-4 py-2 bg-primary text-white rounded">Save</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { Trash2, UserRoundPen } from 'lucide-vue-next'
import api from '@/services/api'

const beneficiaries = ref([])

// Modal state
const modalVisible = ref(false)
const modalDescription = ref('')
const modalAccount = ref('')
const editingBeneficiary = ref(null)
const modalType = ref('internal')

// Fetch beneficiaries
const fetchBeneficiaries = async () => {
  try {
    const res = await api.get('/beneficiaries', {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
    beneficiaries.value = res.data.data
  } catch (err) {
    console.error('Error fetching beneficiaries:', err.response?.data || err)
  }
}

// Filter beneficiaries by type
const beneficiariesFiltered = (...types) => {
  return beneficiaries.value.filter(b => types.includes(b.type))
}

// Open modal to add new beneficiary
const newBeneficiary = (type) => {
  modalType.value = type
  modalDescription.value = ''
  modalAccount.value = ''
  editingBeneficiary.value = null
  modalVisible.value = true
}

// Open modal to edit beneficiary
const editBeneficiary = (beneficiary) => {
  modalType.value = beneficiary.type
  modalDescription.value = beneficiary.description
  modalAccount.value = beneficiary.account_number
  editingBeneficiary.value = beneficiary
  modalVisible.value = true
}

// Save beneficiary (create or update)
const saveBeneficiary = async () => {
  try {
    if (editingBeneficiary.value) {
      // Update
      const res = await api.put(`/beneficiaries/${editingBeneficiary.value.id}`, {
        description: modalDescription.value,
        account_number: modalAccount.value
      }, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      const index = beneficiaries.value.findIndex(b => b.id === editingBeneficiary.value.id)
      beneficiaries.value[index] = res.data.data
    } else {
      // Create
      const res = await api.post('/beneficiaries', {
        description: modalDescription.value,
        account_number: modalAccount.value,
        type: modalType.value
      }, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      beneficiaries.value.push(res.data.data)
    }
    modalVisible.value = false
  } catch (err) {
    console.error('Error saving beneficiary:', err.response?.data || err)
    alert('Error saving beneficiary')
  }
}

// Delete beneficiary
const deleteBeneficiary = async (id) => {
  if (!confirm('Are you sure you want to delete this beneficiary?')) return
  try {
    await api.delete(`/beneficiaries/${id}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
    beneficiaries.value = beneficiaries.value.filter(b => b.id !== id)
  } catch (err) {
    console.error('Error deleting beneficiary:', err.response?.data || err)
    alert('Error deleting beneficiary')
  }
}

onMounted(fetchBeneficiaries)
</script>
